// extracted by mini-css-extract-plugin
export default {"newPost":"new-post_newPost__Z3LLJ","newPostButton":"new-post_newPostButton__4iqx0"};